import { loadStripe } from "@stripe/stripe-js";

const LIVE_PUBLISHABLE_KEY =
  "pk_live_51IsnuYL7zMUGjMIm1nNU9Zm3aokVxpwRCfVGmO2Kn15nlqsdFbtcmgmR6gjsRuRWalzoeNah4VUoR2gwHp5JrhE600c1h6WMxy";

const TEST_PUBLISHABLE_KEY =
  "pk_test_51IsnuYL7zMUGjMImjhBoiA5sCywcn2G0nes3vdNpjJ0R4s0pmZW5iT4pbkVhJYEVJ8VOADlEUhBEwXJCBXY4zouE00Sei8Ccrt";

let liveStripePromise;
let testStripePromise;

export const getStripePromise = (isLive) => {
  if (isLive) {
    if (!liveStripePromise) {
      liveStripePromise = loadStripe(LIVE_PUBLISHABLE_KEY);
    }
    return liveStripePromise;
  }

  if (!testStripePromise) {
    testStripePromise = loadStripe(TEST_PUBLISHABLE_KEY);
  }
  return testStripePromise;
};
